// Workspace mini-map — scaled-down rectangles per card, click to scroll-to.
// Pure presentational: parent passes the canvas bounds + per-card positions.
import type { CardPosition } from './Card';

interface Props {
  positions: { id: string; pos: CardPosition }[];
  canvasW: number;
  canvasH: number;
  onJumpTo: (id: string) => void;
}

const BOX_W = 180;
const BOX_H = 92;

export function MiniMap({ positions, canvasW, canvasH, onJumpTo }: Props) {
  // Compute scale so the largest dimension fits the box. Floor at 0.04 so
  // tiny canvases don't zoom in past usability.
  const scale = Math.max(0.04, Math.min(BOX_W / canvasW, BOX_H / canvasH));
  return (
    <aside className="ws-minimap" aria-label="Workspace overview">
      <div className="ws-minimap__title">Workspace</div>
      <div className="ws-minimap__box">
        {positions.map(({ id, pos }) => (
          <button
            key={id}
            type="button"
            className="ws-minimap__card"
            onClick={() => onJumpTo(id)}
            aria-label={`Jump to ${id}`}
            style={{
              left: pos.x * scale,
              top: pos.y * scale,
              width: Math.max(4, pos.w * scale),
              height: Math.max(4, pos.h * scale),
            }}
          />
        ))}
      </div>
    </aside>
  );
}
